// RTK Query
import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { remove_session } from '../utils/functions';

// Tags
// Every tag an endpoint provides or invalidates MUST be listed here — RTK
// Query throws on an unknown tag, which takes the whole lazy-loaded page down
// with a blank screen and nothing in the console.
export const TAGS = [
  'ROLES_LIST',
  'NUTRITION_CLIENTS_LIST',
  'CLIENT_HEALTH',
  'PLAN_FINDER_QUESTIONS',
  'PLAN_FINDER_RULES',
  'APP_CONFIG',
  'MARKETING_CONFIG',
  'MARKETING_SENDS',
  'MARKETING_FUNNEL',
  'MARKETING_APP_FUNNEL',
  'MARKETING_AUDIENCE',
  'LIVE_CLIENTS',
  'LIVE_CLIENT',
  'LIVE_SESSIONS',
  'INSTAPAY_LIST',
  'SITE_CMS'
];
export const BASE_URL = process.env.REACT_APP_APIPATH;
// export const BASE_URL = 'https://admin.calisfix.com/api/';
// Create baseQuery instance
const baseQuery = async (args, api, extraOptions) => {
  const response = await fetchBaseQuery({
    baseUrl: BASE_URL,
    prepareHeaders: (headers, { getState }) => {
      // By default, if we have a token in the store, let's use that for authenticated requests
      const token = localStorage.userToken;
      if (token) {
        headers.set('Authorization', `Bearer ${token}`);
      }
      return headers;
    }
  })(args, api, extraOptions);
  if (response?.error && response?.error?.status === 401) {
    const token = localStorage.userToken;
    const requestBody = JSON.stringify({ token: token });

    try {
      const response = await fetch(`${BASE_URL}/auth/logout`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`
        },
        body: requestBody
      });

      const responseData = await response.json();
    } catch (error) {
      console.error('Fetch Error:', error);
    }

    remove_session();
    window.location.pathname = '/login';
  }
  return response;
};

// const baseQueryWithRetry = retry(baseQuery, { maxRetries: 3 });

export const baseAPI = createApi({
  reducerPath: 'api',
  baseQuery: baseQuery,
  tagTypes: TAGS,
  // Panel-wide: refetch whatever a page is showing when this tab regains focus,
  // and again when the connection comes back. This is the default rather than
  // something each page opts into, because "the numbers are stale until I hit
  // reload" was true on every page that did not happen to poll. Queries heavy
  // enough that a refetch on every tab switch is wasteful opt OUT at their call
  // site with refetchOnFocus: false.
  refetchOnFocus: true,
  refetchOnReconnect: true,
  endpoints: () => ({})
});
